import "./App.css";
import AppointmentBooking from './component/appointments/AppointmentBooking';
import AppointmentCalendar from './component/appointments/AppointmentCalendar';
import "./css/gobalcolors/colors.css";
import "./css/glass/GlassDesignSystem.css";
import React, { useEffect } from "react";
import OTP from "./component/OTP";
import {
  BrowserRouter as Router,
  Route,
  Routes,
  Link,
  Navigate,
  useNavigate,
} from "react-router-dom";
import { seoRoutesConfig } from "./SeoRoutes";
import ForgotPassword from "./component/ForgotPassword";
import Dashboard from "./component/Dashboard";
import PrivateRoute from "./component/PrivateRoute";
import Cartpage from "./component/Cart/Cartpage";
import Myorderpage from "./component/myorder/Myorderpage";
import Home from "./component/Home";
import Eventspage from "./component/Eventspage";
import EventInvitation from "./component/eventComponent/EventInvitation";
import SignUp from "./component/Signup/SignUp";
import Login from "./component/Login/Login";
import ServiceProviderLogin from "./component/ServiceProviderLogin/ServiceProviderLogin";
import { RSVPInvitationPage } from "./component/RSVPInvitationPage/RSVPInvitationPage";
import { RSVPInvitationPage_pooja } from "./component/RSVPInvitationPage/poojainvitationpage/RsvpInvitationpage_pooja";
import { useDispatch, useSelector } from "react-redux";
import { setCredentials } from "./store/authSlice";
import { getToken } from "./util/Cookies";
import { getRoleFromToken, isTokenExpired } from "./util/authUtils";
import ProtectedRoute from "./component/ProtectedRoute/ProtectedRoute";
import GuestReponseList from "./component/GusetsResponseList/GuestReponseList";
import ServiceProviderSignup from "./component/ServiceProviderSignup/ServiceProviderSignup";
import ServiceProviderOTP from "./component/ServiceProviderOTP";
import ServiceProviderForgotPassword from "./component/ServiceProviderForgotPassword";
import ServiceProviderDashboard from "./component/ServiceProvider/ServiceProviderDashboard";
import EventServices from "./component/EventServices/EventServices";
import EventFormDashboardAdd from "./component/eventComponent/EventFormDashboardAdd";
import EventFormDashboardEdit from "./component/eventComponent/EventFormDashboardEdit";
import EventProviderServices from "./component/EventServices/EventProviderServices";
import MyAccountpage from "./component/MyAccountpage";
import Servicespage from "./component/Services/Servicespage";
import Aboutuspage from "./component/Aboutuspage";
import Contactuspage from "./component/Contactuspage";
import Privacypolicypage from "./component/Privacypolicypage";
import ChildSafetyPage from "./component/ChildSafteyPage";
import AllPolicies from "./component/AllPolicies";
import DataPrivacyPage from "./component/policies/DataPrivacyPage";
import VendorPolicyPage from "./component/policies/VendorPolicyPage";
import UserPolicyPage from "./component/policies/UserPolicyPage";
import AdminIssuesPanel from "./component/policies/AdminIssuesPanel";
import Cancellation_Refund_Policy from "./component/Cancellation&RefundPolicy";
import ShippingDeliveryPolicy from "./component/Shipping&DeliveryPolicy";
import Terms_Conditions from "./component/Terms&Conditions";
import ChildrensPrivacy from "./component/ChildrensPrivacy";
import ComingSoon from "./component/ComingSoon/ComingSoon";
import { homePagePath } from "./constant";
import ThurentHome from "./redesign/components/ThurentHome";
import ThurentLogin from "./redesign/components/Auth/ThurentLogin";
import ThurentSignUp from "./redesign/components/Auth/ThurentSignUp";
import ThurentForgotPassword from "./redesign/components/Auth/ThurentForgotPassword";
import ThurentServiceProviderLogin from "./redesign/components/Auth/ThurentServiceProviderLogin";
import ThurentServiceProviderForgotPassword from "./redesign/components/Auth/ThurentServiceProviderForgotPassword";
import ThurentServiceProviderSignUp from "./redesign/components/Auth/ThurentServiceProviderSignUp";
import CateringService from "./redesign/components/Services/CateringService";
import AIEnabledEventDetailServices from "./redesign/components/Services/AIEnabledEventDetailServices";
import SendInvitationService from "./redesign/components/Services/SendInvitationService";
import BookPriestService from "./redesign/components/Services/BookPriestService";
import RentFromTentHouse from "./redesign/components/Services/RentFromTentHouse";
import ManageProfileTabContent from "./component/ServiceProvider/ManageProfileTabContent";
import InvoicePage from "./component/ServiceProvider/InvoicePage";
import CheckoutPage from "./component/ServiceProvider/CheckoutPage"
import { ManageProfileTabContentView } from "./component/ServiceProvider/ManageProfileTabContentView";
import SupportPage from "./component/SupportPage/SupportPage";
import Error404 from "./redesign/components/Errorpages/Error404";
import Error401 from "./redesign/components/Errorpages/Error401";
import { useLocation } from "react-router-dom";
import VenueBookingScreen from "./component/VenueBookingScreen";


function App() {
  const dispatch = useDispatch();
  const [authChecked, setAuthChecked] = React.useState(false);
  // const token = getToken();
  // const isLoggedIn = token && !isTokenExpired(token);
  // const role = token ? getRoleFromToken(token) : null ;


  useEffect(() => {
    const token = getToken();

    if (token) {
      const role = getRoleFromToken(token);
      dispatch(setCredentials({ token, role })); //  dispatch both token + role
    }
    setAuthChecked(true); // 👈 mark that auth check is done

    // if (isLoggedIn) {
    //   console.log("Allready Logged In ", token);
    //   dispatch(setCredentials({ token }));
    // }

  }, [dispatch]);
  const { isLoggedIn, role } = useSelector((state) => state.auth);
  const getRedirectPath = () => {
    switch (role) {
      case "customer":
        return "/dashboard";
      case "admin":
        return "/admin-dashboard";
      case "provider":
        return "/service-provider/dashboard";
      default:
        return homePagePath;
    }
  };
  if (!authChecked) {
    return null;
  }
  return (
    <div className="App">
      <Router>
        <Routes>
          {/* Public Routes */}
          <Route
            path="/login"
            element={
              isLoggedIn ? (
                <Navigate to={getRedirectPath()} replace />
              ) : (
                <ThurentLogin />

              )
            }
          />
          <Route
            exact
            path="/invitation/:sharedToken"
            // Component={EventInvitation}
            Component={RSVPInvitationPage_pooja}
          />
          {/* <Route path="/" element={<ComingSoon />} /> */}
          {/* <Route
            exact
            path="/invitation/:sharedToken"
            // Component={EventInvitation}
            Component={ RSVPInvitationPage_pooja}
          />
            */}
          <Route
            path={homePagePath}
            element={
              isLoggedIn ? (
                <Navigate to={getRedirectPath()} replace />
              ) : (
                <ThurentHome />

              )
            }
          />
          {seoRoutesConfig.map((route, index) => (
            <Route
              key={index}
              path={route.path}
              element={route.element}
              exact={route.exact}
            />
          ))}
          <Route path="/otp" Component={OTP} />
          <Route
            path="/signup"
            element={
              isLoggedIn ? (
                <Navigate to={getRedirectPath()} replace />
              ) : (
                <ThurentSignUp />

              )
            }
          />
          <Route
            path="/forgot-password"
            Component={ThurentForgotPassword}
          ></Route>
          <Route path="/about-us" Component={Aboutuspage}></Route>
          <Route path="/contact" Component={Contactuspage}></Route>
          <Route path="/support" Component={SupportPage}></Route>
          <Route path="/invoice" element={<InvoicePage />} />
          <Route path="/checkout" element={<CheckoutPage />} />
          <Route path="/privacy-policy" Component={Privacypolicypage}></Route>
          <Route path="/child-safety" Component={ChildSafetyPage}></Route>
          <Route path="/all-policies" Component={AllPolicies}></Route>
          <Route path="/data-privacy" Component={DataPrivacyPage}></Route>
          <Route path="/vendor-policy" Component={VendorPolicyPage}></Route>
          <Route path="/user-policy" Component={UserPolicyPage}></Route>
          <Route path="/admin/issues" element={
            <ProtectedRoute requiredRole="admin">
              <AdminIssuesPanel />
            </ProtectedRoute>
          } />
          <Route path="/Cancellation-Refund_Policy" Component={Cancellation_Refund_Policy}></Route>
          <Route path="/Shipping_DeliveryPolicy" Component={ShippingDeliveryPolicy}></Route>
          <Route path="/Terms_Conditions" Component={Terms_Conditions}></Route>
          <Route path="/children-privacy" Component={ChildrensPrivacy}></Route>
          <Route exact={true} path="/event/:slug" Component={Eventspage} />

          <Route
            exact={true}
            path="/service/book-catering"
            Component={CateringService}
          />
          <Route
            exact={true}
            path="/service/ai-enabled-event-details"
            Component={AIEnabledEventDetailServices}
          />
          <Route
            exact={true}
            path="/service/invite"
            Component={SendInvitationService}
          />
          <Route
            exact={true}
            path="/service/hire-a-priest"
            Component={BookPriestService}
          />
          <Route
            exact={true}
            path="/service/hire-a-priest"
            Component={BookPriestService}
          />
          <Route
            exact={true}
            path="/service/rental-services-for-events"
            Component={RentFromTentHouse}
          />

          {/* <Route exact={true} path="/service/:slug" Component={Servicespage} /> */}

          <Route
            path="/service/:slug"
            element={
              isLoggedIn && role === "provider" ? (
                <Navigate to="/service-provider/dashboard" replace />
              ) : (
                <Servicespage />

              )
            }
          />

          <Route
            path="/service-provider/login"
            element={
              isLoggedIn ? (
                <Navigate to="/service-provider/dashboard" replace />
              ) : (
                <ThurentServiceProviderLogin />

              )
            }
          />
          <Route
            path="/service-provider/info/:id"
            element={<ManageProfileTabContentView />}
          />
          <Route path="/service-provider/otp" Component={ServiceProviderOTP} />
          <Route
            path="/service-provider/signup"
            element={
              isLoggedIn ? (
                <Navigate to="/service-provider/dashboard" replace />
              ) : (
                <ThurentServiceProviderSignUp />

              )
            }
          />
          <Route
            path="/service-provider/forgot-password"
            Component={ThurentServiceProviderForgotPassword}
          ></Route>

          {/* This Path Should be for Customer only  */}
          <Route
            path="/dashboard"
            element={
              <ProtectedRoute requiredRole="customer">
                <Dashboard />
              </ProtectedRoute>
            }
          ></Route>

          <Route
            path="/dashboard/my-account"
            element={
              <ProtectedRoute requiredRole="customer">
                <MyAccountpage />
              </ProtectedRoute>
            }
          ></Route>

          <Route
            path="/dashboard/event/guests"
            element={
              <ProtectedRoute requiredRole="customer">
                <GuestReponseList />
              </ProtectedRoute>
            }
          ></Route>
          <Route
            path="/dashboard/event/create"
            element={
              <ProtectedRoute requiredRole="customer">
                <EventFormDashboardAdd />
              </ProtectedRoute>
            }
          ></Route>
          <Route
            path="/dashboard/event/edit"
            element={
              <ProtectedRoute requiredRole="customer">
                <EventFormDashboardEdit />
              </ProtectedRoute>
            }
          ></Route>

          <Route
            path="/providers"
            element={
              <ProtectedRoute requiredRole="customer">
                <EventServices
                  key={window.location.state?.serviceDetails?.id || "default"}
                />
              </ProtectedRoute>
            }
          ></Route>

          <Route
            path="/provider/services"
            element={
              <ProtectedRoute requiredRole="customer">
                <EventProviderServices />
              </ProtectedRoute>
            }
          ></Route>

          {/* Admin Routes */}
          <Route
            path="/admin-dashboard"
            element={
              <ProtectedRoute requiredRole="admin">
                {/* <AdminDashboard /> */}
                <h1>Admin</h1>
              </ProtectedRoute>
            }
          />
          <Route path="/venue-booking" element={<VenueBookingScreen />} />
          <Route path="/venue-booking/:venueId" element={<VenueBookingScreen />} />

          {/* This Path Should be for Provider Only */}
          <Route
            path="/service-provider/dashboard"
            element={
              <ProtectedRoute requiredRole="provider">
                <ServiceProviderDashboard />
              </ProtectedRoute>
            }
          ></Route>
          <Route
            path="/cart"
            element={
              <ProtectedRoute requiredRole="customer">
                <Cartpage />
              </ProtectedRoute>
            }
          ></Route>

          <Route
            path="/myorder"
            element={
              <ProtectedRoute requiredRole="customer">
                <Myorderpage />
              </ProtectedRoute>
            }
          ></Route>
          {/* Fallback URL  */}
          {/* <Route path="*" element={<Navigate to="/" />} /> */}
          <Route path="/appointments/book/:providerId" element={<ProtectedRoute requiredRole="customer"><AppointmentBooking /></ProtectedRoute>} />
          <Route path="/dashboard/calendar" element={<ProtectedRoute requiredRole="customer"><AppointmentCalendar /></ProtectedRoute>} />
          <Route path="/service-provider/calendar" element={<ProtectedRoute requiredRole="provider"><AppointmentCalendar provider /></ProtectedRoute>} />
          <Route path="/401" element={<Error401 />} />
          <Route path="/404" element={<Error404 />} />
          <Route path="*" element={<Error404 />} />


        </Routes>
      </Router>
    </div>
  );
}

export default App;
